import React from "react";
import PropTypes from "prop-types";
import "./style.css";

const VaporInput = ({
  alertMessage,
  disabled,
  hasError,
  label,
  onChange,
  onKeyPress,
  placeholder,
  readOnly,
  style,
  type,
  value
}) => {
  return (
    <div
      className={"vapor-input " + (hasError ? "has-errors" : "")}
      style={style}
    >
      {label && <label htmlFor="textInput">{label}</label>}
      <input
        type={type || "text"}
        className="vapor-form_control"
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        onChange={onChange}
        onKeyPress={onKeyPress}
      />
      {alertMessage && <span>{alertMessage}</span>}
    </div>
  );
};

VaporInput.propTypes = {
  alertMessage: PropTypes.string,
  disabled: PropTypes.bool,
  hasError: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
  onKeyPress: PropTypes.func,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  style: PropTypes.object,
  value: PropTypes.string
};

VaporInput.defaultProps = {
  alertMessage: "",
  disabled: false,
  hasError: false,
  onChange: () => {},
  onKeyPress: () => {},
  placeholder: "",
  readOnly: false,
  style: {},
  value: ""
};

export default VaporInput;
